import { combineReducers } from 'redux';
import commonReducer from './common-reducer';
import language from './lang';


export default combineReducers({
  commonStates: commonReducer,
  language,
});
